import { Component, Input, OnInit } from '@angular/core';
import { FormType } from '../../form-designer/form-type.enum';
import { ReferenceLibraryService } from 'reference-library';
import { take } from 'rxjs/operators';
import { ReferenceLibrary } from 'app-models';
import { FdDetailNavSectionService } from '../../form-designer/fd-detail-nav-section/fd-detail-nav-section.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/data/models/app-state';
import * as FB from 'src/app/modules/form-designer/fb-state/actions/fb.actions';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-fb-vertical-tab',
  templateUrl: './fb-vertical-tab.component.html',
  styleUrls: ['./fb-vertical-tab.component.scss']
})
export class FbVerticalTabComponent implements OnInit {
  @Input() formBuilderInfo: any;
  activeIndex: any;
  fbTabFormType: any;
  pageFormType: any;
  simpleFormButton: any;
  fbPageTypeArr: ReferenceLibrary[];
  formTypeSelected: string;
  isFBModulePreview = false;
  tabFormBuilderInfo: any;
  formBuilderTabInfo: any;
  formDataId: any;
  showSimpleForm: boolean;
  showPageTitleSection: boolean;
  selectedIndex: number;
  isMultiStepForm: boolean = null;
  steps: any[] = [];
  buttonClicked: boolean = false;
  onBackToMasterListReference: any;
  isHandleClicked: boolean = false;

  constructor(
    private referenceLibraryService: ReferenceLibraryService,
    private fdDetailNavSectionService: FdDetailNavSectionService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // console.log("formBuilderInfo  Vertical Tab", this.formBuilderInfo);
    //this.selectedIndex = 0;
    //this.onLoadTabFormInfo(0);
    //this.onClickTab(0)

    this.activeIndex = this.fdDetailNavSectionService.getActiveTabIndex();
    this.onLoadTabFormInfo(this.activeIndex);
  }

  getTabPageFormInfo(tabPageFormId) {

    this.fdDetailNavSectionService.getPageFormById(tabPageFormId)
      .pipe(take(1)).subscribe((formBuilderTabInfo: any) => {
        if (formBuilderTabInfo) {
          this.formBuilderTabInfo = formBuilderTabInfo;
          sessionStorage.setItem('moduleId', this.formBuilderTabInfo.moduleId);
          sessionStorage.setItem('pageFormId', this.formBuilderTabInfo.id);
          this.simpleFormButton = this.formBuilderTabInfo?.formBuilderPageFormButtons?.[0] || null;
          this.getSimpleFormDetails();
          if (this.simpleFormButton && this.fbPageTypeArr) {
            this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
          }
          if (this.pageFormType === 'master_listing_table') {
            this.showPageTitleSection = true;
            this.showSimpleForm = false;
            this.isMultiStepForm = false;
          } else {
            if (this.formTypeSelected === 'MultiStep') {
              this.showSimpleForm = false;
              this.isMultiStepForm = true;
            } else {
              this.showSimpleForm = true;
              this.showPageTitleSection = this.pageFormType === 'form_builder_dashboard' ? true : false;
            }

          }
        }
        // this.showPageInfo = true;
      });
  }
  getSteps(): any[] {
    if (this.simpleFormButton && this.simpleFormButton.pageFormJson) {
      const pageFormJson = JSON.parse(this.simpleFormButton.pageFormJson);

      if (Array.isArray(pageFormJson)) {
        const filteredFields = pageFormJson.filter(field => !('emptyCol' in field && field.emptyCol) && !(field.isOmit === true));

        const uniqueStepNumbers = [...new Set(filteredFields.map(field => field.stepNumber || 1))];

        return uniqueStepNumbers.map(stepNumber => {
          const stepFields = filteredFields.filter(field => (field.stepNumber || 1) === stepNumber);
          const stepLabel = stepFields.length > 0 ? stepFields[0].stepName || `Step ${stepNumber}` : `Step ${stepNumber}`;
          return {
            label: stepLabel,
            simpleFormButton: this.simpleFormButton,
            pageFormType: this.pageFormType,
            formTypeSelected: this.formTypeSelected,
            isFBModulePreview: this.isFBModulePreview,
            formBuilderInfo: this.formBuilderInfo,
            formDataId: this.formDataId,
            stepNumber: stepNumber || 1,
            fields: stepFields,
          };
        }).filter((step, index, self) => {
          return index === self.findIndex(s => s.stepNumber === step.stepNumber);
        });
      }
    }

    return [
      {
        label: 'Step 1',
        simpleFormButton: this.simpleFormButton,
        pageFormType: this.pageFormType,
        formTypeSelected: this.formTypeSelected,
        isFBModulePreview: this.isFBModulePreview,
        formBuilderInfo: this.formBuilderInfo,
        formDataId: this.formDataId,
        stepNumber: 1,
        fields: [],
      },
    ];
  }

  getSimpleFormDetails() {
    this.referenceLibraryService.getReferenceData('FB_PAGE_TYPE')
      .pipe(take(1))
      .subscribe((response: any) => {
        this.fbPageTypeArr = response;
        if (this.simpleFormButton && this.fbPageTypeArr) {
          // this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.formBuilderInfo.fbPageFormTabs[0].buildFormatTypeId).code;
          this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
          if (this.formTypeSelected === 'MultiStep') {
            this.steps = this.getSteps();
            this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
          }
        }
      });
  }

  handleTabChange(e) {
    //  console.log("e", e);
    //this.selectedIndex = e.index;
    this.activeIndex = e.index;
    this.showPageTitleSection = false;
    this.formBuilderTabInfo = null;
    this.showSimpleForm = false;
    this.isMultiStepForm = false;
    this.formTypeSelected = null;
    this.simpleFormButton = null;
    this.formDataId = null;
    sessionStorage.removeItem("pageFormId");
    this.onLoadTabFormInfo(e.index);
    this.fdDetailNavSectionService.setActiveTabIndex(this.activeIndex);
  }

  onBackToMasterList() {
    this.showSimpleForm = false;
    this.simpleFormButton = null;
    this.isMultiStepForm = false;
    const tabPageFormId = this.formBuilderInfo.fbPageFormTabs[this.activeIndex].pageFormId;
    this.getTabPageFormInfo(tabPageFormId);
  }
  onLoadTabFormInfo(index) {
    this.pageFormType = FormType[this.formBuilderInfo.fbPageFormTabs[index].buildFormatTypeId];
    const tabPageFormId = this.formBuilderInfo.fbPageFormTabs[index].pageFormId;
    this.getTabPageFormInfo(tabPageFormId);
  }

  handleAction(e) {
    if (!e.isBeneficiaryProfileListing) {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      if (this.fbPageTypeArr) {
        this.simpleFormButton = this.formBuilderInfo.formBuilderPageFormButtons[0];
        this.formTypeSelected = this.fbPageTypeArr.find(x => x.id === this.simpleFormButton.pageFormTypeId).code;
      }
    } else {
      sessionStorage.setItem('FbEmployeeId', e.beneficiaryId);
    }
    if (e.isBeneficiaryProfileListing && e.redirectTo === 0) {
      this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
      setTimeout(() => {
        this.router.navigate([`../employee/profile/education`], {
          queryParams: {
            pageFrom: 'FB',
            fbEmpId: e.id
          },
          relativeTo: this.route
        });
      }, 0);
    } else {
      sessionStorage.setItem('formDataId', e.id);
      this.formDataId = e.id;
      if (this.formTypeSelected === 'MultiStep') {
        this.steps = this.getSteps();
        this.showSimpleForm = false;
        this.isMultiStepForm = true;
        this.onBackToMasterListReference = this.onBackToMasterList.bind(this);
        //this.buttonClicked = true;
      } else {
        this.isMultiStepForm = false;
        this.showSimpleForm = true;
      }
    }
    this.isHandleClicked = true;
  }

  onPageFormButtonClicked(item: any) {
    this.simpleFormButton = item;
    this.buttonClicked = true;
    if (this.formTypeSelected === 'MultiStep') {
      this.isMultiStepForm = true;
      this.showSimpleForm = false;
    } else {
      this.showSimpleForm = true;
      this.isMultiStepForm = false;
    }
    this.formDataId = null;
    //  this.isShowPageTitleSection();
  }

  ngOnDestroy(): void {
    if (!this.buttonClicked && !this.isHandleClicked) {
      this.fdDetailNavSectionService.setActiveTabIndex(0);
    }
  } 

  // isShowPageTitleSection(onMenuClick: boolean = false) {
  //   if (this.formBuilderTabInfo) {
  //     if (this.pageFormType === 'master_listing_table' && (this.showSimpleForm || onMenuClick)) {
  //       if (onMenuClick) {
  //         this.showPageTitleSection = true;
  //         this.showSimpleForm = false;
  //       } else if (this.showSimpleForm && this.simpleFormButton) {
  //         this.showPageTitleSection = false;
  //         this.getSimpleFormDetails();
  //       }
  //     } else if (['simple_form', 'form_builder_dashboard'].includes(this.pageFormType)) {
  //       this.showPageTitleSection = true;
  //       this.simpleFormButton = this.formBuilderTabInfo.formBuilderPageFormButtons[0];
  //       this.getSimpleFormDetails();
  //     }
  //   } else {
  //     this.showPageTitleSection = false;
  //     this.showSimpleForm = false;
  //     this.simpleFormButton = null;
  //   }
  // }




}
